import {
  DROP_INVOICES_DATA,
  FETCH_INVOICES,
  RESET_INVOICES_DATA,
} from 'modules/Finance/Invoices/store/types'

export const actionGetInvoices = (props) => ({
  type: FETCH_INVOICES,
  payload: props,
})

export const actionDropInvoices = (props) => ({
  type: DROP_INVOICES_DATA,
  payload: props,
})

export const actionResetInvoices = (props) => ({
  type: RESET_INVOICES_DATA,
  payload: props,
})
